import React from "react";
import { ApplicationPracticalExperienceDto } from "../../../types/applicationTypes";
import { Box, Divider, Typography } from "@mui/material";
import WorkExperience from "./WorkExperience";
import ProfileDataCard from "./ProfileDataCard";

interface InternshipsProps {
  internships: ApplicationPracticalExperienceDto[];
}

/**
 * This component displays the internships of an applicant.
 * @param internships The internships of an applicant.
 * @returns The internships of an applicant.
 */
const Internships = ({ internships }: InternshipsProps) => {
  return (
    <ProfileDataCard title={internships.length > 1 ? "Praktika" : "Praktikum"}>
      {internships.length === 0 ? (
        <Typography>Keine Angaben</Typography>
      ) : (
        internships.map((internship, index) => {
          // if it is the last item, don't add margin and divider
          if (index === internships.length - 1) {
            return (
              <WorkExperience
                key={index}
                jobTitle={internship.activity}
                company={internship.company}
                location={internship.location}
                start={internship.start ? internship.start : null}
                end={internship.end ? internship.end : null}
              />
            );
          }
          return (
            <Box key={index} mb={2}>
              <WorkExperience
                key={index}
                jobTitle={internship.activity}
                company={internship.company}
                location={internship.location}
                start={internship.start ? internship.start : null}
                end={internship.end ? internship.end : null}
              />
              <Divider sx={{ mt: 2 }} />
            </Box>
          );
        })
      )}
    </ProfileDataCard>
  );
};

export default Internships;
